import './assets.css';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faUpLong} from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

function loadAssets(setAssets) {
    fetch('/v1/api/assets', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'x-Content-Range': 'items=0-1000',
        },
    })
        .then(response => response.json())
        .then(data => {
            setAssets(data);
        })
        .catch(error => {
            toast.error('Failed to fetch assets.');
        });
}

function deleteAsset(assetId, assets, setAssets) {
    fetch(`/v1/api/assets/${assetId}`, {
        method: 'DELETE',
    }).then(response => {
        if (response.ok) {
            toast.success('Asset deleted successfully.');
            setAssets(assets.filter(asset => asset.id !== assetId));
        } else {
            toast.error('Failed to delete asset.');
        }
    });
}

function uploadAsset(quill, setAssets) {
    const filename = document.getElementById('filename').value;
    fetch('/v1/api/assets', {
        method: 'PUT',
        body: JSON.stringify({
            alias: filename,
            base64: btoa(quill || ''),
        }),
    }).then(response => {
        if (response.ok) {
            toast.success('Asset uploaded successfully.');
            loadAssets(setAssets);
        } else {
            toast.error('Failed to upload asset.');
        }
    });
}

export default function Assets({ currentPage, fnSetCurrentPage }) {
    const [assets, setAssets] = useState([]);
    const [quill, setQuill] = useState('');

    useEffect(() => {
        loadAssets(setAssets);
    }, []);

    return <div className='assets'>
        <div className='table'>
            <table>
                <thead>
                    <tr hidden>
                        <th>Asset Name</th>
                        <th>MIME Type</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {assets.map((asset) => (
                        <tr key={asset.id}>
                            <td className='col-alias'>{asset.alias}</td>
                            <td className='col-mimetype'>{asset.mimetype}</td>
                            <td className='col-actions'>
                                <button title='Delete' onClick={() => deleteAsset(asset.id, assets, setAssets)}><FontAwesomeIcon icon={faXmark} /></button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
        <main>
            <div className='actions'>
                <input id='filename' type='text' placeholder='filename'/>
                <button onClick={() => uploadAsset(quill, setAssets)} title='Upload'><FontAwesomeIcon icon={faUpLong} /></button>
            </div>
            <ReactQuill theme='snow' value={quill} onChange={setQuill} modules={{
                toolbar: [
                    [{ 'header': [1, 2, false] }],
                    ['bold', 'italic', 'underline'],
                    ['link', 'image', 'video'],
                    ['clean'],
                    [{ 'align': [] }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                ],
            }} />
        </main>
        <ToastContainer />
    </div>
}
